import React, { useState, useRef, useEffect } from "react";

import { useFormCtx } from "./FormContext";
import useScreenType from "./hooks/useScreenType";

import * as Const from "./_Const";

import Navbar from "./components/Navbar";
import Button from "./components/Button";
import ScaleSpinnerProgressSection from "./components/ScaleSpinnerProgressSection";

function PageHwSwInfo() {
  const screenType = useScreenType();
  const [data, setData] = useState();
  const { getTerminalHwInfo, isTaskRunning, terminalSettingsState } = useFormCtx();
  const textareaRef = useRef(null);

  useEffect(() => {
    async function scopedLoadData() {
      await readData();
    }

    scopedLoadData();
  }, []);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.scrollTop = textareaRef.current.scrollHeight;
    }
  }, [data]);

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "key":
          css = "min-w-[108px] text-secondary text-sm";
          break;
        case "val":
          css = "ml-2 text-sm";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-xl text-accent-dark mt-2";
          break;
        case "footer":
          css = "h-[65px]";
          break;
        case "parent":
          css = "h-[416px]";
          break;
        case "btn":
          css = "h-14 text-sm";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "key":
          css = "min-w-[190px] text-secondary text-xl";
          break;
        case "val":
          css = "ml-4 text-xl";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-2xl text-accent-dark mt-4";
          break;
        case "footer":
          css = "h-[100px]";
          break;
        case "parent":
          css = "h-[624px]";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "key":
          css = "min-w-[190px] text-secondary text-xl";
          break;
        case "val":
          css = "ml-4 text-xl";
          break;
        case "block":
          css = "mx-4";
          break;
        case "block-title":
          css = "text-2xl text-accent-dark mt-4";
          break;
        case "footer":
          css = "h-[100px]";
          break;
        case "parent":
          css = "h-[704px]";
          break;
        case "btn":
          css = "h-20";
          break;
      }
    }

    return css;
  }

  async function readData() {
    const result = await getTerminalHwInfo();
    setData(result?.data);
  }

  /*
data = {
            "model": model,
            "temperature": temp,
            "cpu": cpu,
            "ram": ram,
            "disk": disk,
            "camera": camera,
            "connection": net_type,
            "ip": ip,
            "ip_method": ip_method,
            "mask": mask,
            "gate": gate,
            "dns": dns,
            "uid": uid,
            "script": __version__,
            "api_url": apiUrl,
            "push_service": push_service,
            "terminal_service": terminal_service,
            "chromium_url": chromium_url            
        }
*/

  const camera = data?.camera?.slice(0, data?.camera?.indexOf("]") + 1);
  const temp = data?.temperature ? data?.temperature / 1000 : 0;
  //console.log(data);

  return (
    <>
      <Navbar useCustomTitle={true} customTitle={"Informace o terminálu - HW - SW"} />
      {(isTaskRunning || !data) && <ScaleSpinnerProgressSection />}
      {!isTaskRunning && data && (
        <div className={`${getCssFor("parent")} flex flex-col overflow-hidden`}>
          <div className="flex-1 overflow-y-auto grid grid-cols-2 mb-2">
            {/* 1. radek  */}
            <div className={`${getCssFor("block")}`}>
              <h1 className={`${getCssFor("block-title")}`}>HW informace:</h1>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Model:</div>
                <div className={`${getCssFor("val")}`}>{data?.model}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Teplota:</div>
                <div className={`${getCssFor("val")}`}>{temp}°C </div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>CPU vytížení:</div>
                <div className={`${getCssFor("val")}`}>{data?.cpu}%</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>RAM zaplnění:</div>
                <div className={`${getCssFor("val")}`}>{data?.ram}%</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>DISK zaplnění:</div>
                <div className={`${getCssFor("val")}`}>{data?.disk}%</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Kamera:</div>
                <div className={`${getCssFor("val")}`}>{camera}</div>
              </div>
            </div>

            <div className={`${getCssFor("block")}`}>
              <h1 className={`${getCssFor("block-title")}`}>Síťové informace:</h1>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Připojení:</div>
                <div className={`${getCssFor("val")}`}>{data?.connection}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>IP:</div>
                <div className={`${getCssFor("val")}`}>{data?.ip}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Přidělení IP:</div>
                <div className={`${getCssFor("val")}`}>{data?.ip_method}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Maska:</div>
                <div className={`${getCssFor("val")}`}>{data?.mask}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Brána:</div>
                <div className={`${getCssFor("val")}`}>{data?.gate}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>DNS:</div>
                <div className={`${getCssFor("val")}`}>{data?.dns}</div>
              </div>
            </div>

            {/* 2. radek  */}
            <div className={`${getCssFor("block")}`}>
              <h1 className={`${getCssFor("block-title")}`}>Terminál + TERMINAL_APP:</h1>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Verze scriptu:</div>
                <div className={`${getCssFor("val")}`}>{data?.script}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Terminál:</div>
                <div className={`${getCssFor("val")}`}>{data?.uid}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Mobile UID:</div>
                <div className={`${getCssFor("val")}`}>{terminalSettingsState.mobileUID}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Klíč:</div>
                <div className={`${getCssFor("val")}`}>{terminalSettingsState.keyNumber}</div>
              </div>

              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>API URL:</div>
                <div className={`${getCssFor("val")}`}>{data?.api_url}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>PUSHY Service:</div>
                <div className={`${getCssFor("val")}`}>{data?.push_service}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Terminal Service:</div>
                <div className={`${getCssFor("val")}`}>{data?.terminal_service}</div>
              </div>
            </div>
            <div className={`${getCssFor("block")}`}>
              <h1 className={`${getCssFor("block-title")}`}>Web Aplikace:</h1>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Verze scriptu:</div>
                <div className={`${getCssFor("val")}`}>{Const.APP_VERSION}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Enviroment:</div>
                <div className={`${getCssFor("val")}`}>{Const.ENV}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Web App URL:</div>
                <div className={`${getCssFor("val")}`}>{Const.APP_URL}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>Chromium URL:</div>
                <div className={`${getCssFor("val")}`}>{data?.chromium_url}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>API URL:</div>
                <div className={`${getCssFor("val")}`}>{Const.API_URL}</div>
              </div>
              <div className="text-primary flex">
                <div className={`${getCssFor("key")}`}>TERMINAL_APP:</div>
                <div className={`${getCssFor("val")}`}>{Const.TERMINAL_APP_URL}</div>
              </div>
            </div>
          </div>
          <div className={`${getCssFor("footer")} bg-disabled-darka flex items-center place-content-center justify-center`}>
            <Button type="primary" title="Načíst hodnoty" showIcon={false} onClick={() => readData()} className={`${getCssFor("btn")} `} />
          </div>
        </div>
      )}
    </>
  );
}

export default PageHwSwInfo;
